<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p49"><span><a id="page_37"></a><a href="#/Contents#rp49">BLACK MUSHROOM SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Chinese black mushrooms (dried shiitake mushrooms) add a fragrant, woodsy flavor to this soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>2 cups boiling water</span></p>
<p class="hang"><span>1½ ounces dried Chinese black mushrooms</span></p>
<p class="hang"><span>1 ounce dried cloud ear mushrooms</span></p>
<p class="hang"><span>¼ cup each: chopped onion, green onions</span></p>
<p class="hang"><span>5 cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>3 cups sliced cremini mushrooms</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Pour boiling water over dried mushrooms in bowl; let stand until mushrooms are softened, about 15 minutes. Drain, reserving liquid. Slice mushrooms, discarding tough stems from black mushrooms.</span></p>
<p class="normala"><span><b>2.</b> Sauté onion and green onions in lightly greased large saucepan until tender, about 5 minutes. Add dried mushrooms, reserved liquid and broth; heat to boiling. Reduce heat and simmer, covered, 20 minutes, adding cremini mushrooms during last 10 minutes. Season to taste with salt and white pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 72</span></p>
<p class="per1"><span>% calories from fat: 16</span></p>
<p class="per1"><span>Protein (g): 2.9</span></p>
<p class="per1"><span>Carbohydrate (g): 11.1</span></p>
<p class="per1"><span>Fat (g): 1.4</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 10</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 3.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0230.vue?34904827